module.exports = __webpack_public_path__ + "static/media/ceilings_material_10y_n.8caed77f.csv";